export default __webpack_public_path__ + "static/media/blank.bc922c74.jpg";